export default "__VITE_ASSET__IXIG2dti__"